import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProjectStatusModel} from './project.status.model';
import {BreakpointService} from "@proleis/proleis-web-app";

@Component({
  selector: 'ps-project-status-external',
  templateUrl: 'project.status.external.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectStatusExternalComponent implements OnInit {

  @Output()
  statusChanged: EventEmitter<ProjectStatusModel> = new EventEmitter<ProjectStatusModel>();
  @Input()
  editable: boolean;

  mobile: boolean;

  _currentStatus: ProjectStatusModel = undefined;
  _previousStatus: ProjectStatusModel = undefined;

  constructor(private breakpointService: BreakpointService) {

  }

  @Input()
  set currentStatus(status: ProjectStatusModel) {
    this._currentStatus = status;
  }

  get currentStatus() {
    return this._currentStatus;
  }

  @Input()
  set previousStatus(status: ProjectStatusModel) {
    this._previousStatus = status;
  }

  get previousStatus() {
    return this._previousStatus;
  }


  ngOnInit() {
    this.breakpointService.isSmall().subscribe(mobile => {
      this.mobile = mobile;
    });
  }

  isDifferent(a: any, b: any): boolean {
    if (!a || !b) {
      return false;
    }
    return a !== b;
  }

  onChange() {
    this.statusChanged.next(this.currentStatus);
  }

  compareComplexity(o1: any, o2: any) {
    return String(o1) === String(o2);
  }

}
